/**
 * Admin Analytics page component.
 *
 * Route: `/admin/analytics`
 * Requires authentication: Yes (admin only)
 *
 * @module AdminAnalyticsPage
 */

import { useTranslation } from 'react-i18next';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import AdminStats from '@/components/admin/AdminStats';
import QuestionsAnalysis from '@/components/admin/analytics/QuestionsAnalysis';
import FeedbackAnalytics from '@/components/admin/analytics/FeedbackAnalytics';
import {
  BarChart3,
  FileQuestion,
  MessageSquareHeart,
} from 'lucide-react';

export default function AdminAnalyticsPage() {
  const { t } = useTranslation();
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-foreground font-ui">
          Analytics Dashboard
        </h2>
        <p className="text-muted-foreground mt-1 font-ui">
          Comprehensive analysis across all system components
        </p>
      </div>

      <Tabs defaultValue="overview" className="w-full">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="overview" className="flex items-center gap-2">
            <BarChart3 className="h-4 w-4" />
            <span className="hidden sm:inline font-ui">Overview</span>
          </TabsTrigger>
          <TabsTrigger value="questions" className="flex items-center gap-2">
            <FileQuestion className="h-4 w-4" />
            <span className="hidden sm:inline font-ui">Questions</span>
          </TabsTrigger>
          <TabsTrigger value="feedback" className="flex items-center gap-2">
            <MessageSquareHeart className="h-4 w-4" />
            <span className="hidden sm:inline font-ui">{t('feedbackAnalytics.tab')}</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="overview" className="mt-6">
          <AdminStats />
        </TabsContent>

        <TabsContent value="questions" className="mt-6">
          <QuestionsAnalysis />
        </TabsContent>

        <TabsContent value="feedback" className="mt-6">
          <FeedbackAnalytics />
        </TabsContent>
      </Tabs>
    </div>
  );
}
